import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import useAvatarUpload from '@/modules/playground/hooks/useAvatarUpload.hook';
import Link from '@/core/design-system/Link';
import TrafficStats from './general-metrics/traffic-stats';
import SourceMetrics from './source-metrics';
import TrafficGraph from './general-metrics/traffic-graph';
import CountryMetrics from './country-metrics';
import UserAgentMetrics from './useragent-metrics';
import CardMetrics from './card-metrics';
import { ExternalIcon } from '@/assets/icons/external.icon';
import DateFilter from './date-filter';
import FiltersBar from './filters-bar';

const Analytics = () => {
  const { state, getShareableDomain, openPreview } = usePlayground();
  const { getAvatarSrc } = useAvatarUpload();

  return (
    <>
      <div className="flex items-center justify-between flex-col md:flex-row">
        <div className="flex items-center gap-x-4 mb-6 md:mb-0">
          {state.payload._id ? (
            <img src={getAvatarSrc()} alt="Avatar" className="w-12 h-12 md:w-20 md:h-20 rounded-full object-cover" />
          ) : (
            <div className="w-24 h-24 bg-dark animate-pulse rounded-full"></div>
          )}

          <div>
            <h1 className="text-lighter text-2xl font-bold mb-1">Analytics</h1>
            <Link
              to="#"
              className="flex items-center gap-x-2 text-input-focus text-xs font-bold hover:text-input-focus"
              onClick={(e) => {
                e.preventDefault();
                openPreview();
              }}
            >
              {getShareableDomain()}
              <ExternalIcon />
            </Link>
          </div>
        </div>

        <DateFilter />
      </div>

      <div className="w-full h-[1px] bg-secondary my-6" />

      <TrafficStats />

      <div className="w-full h-[1px] bg-secondary my-6" />

      <TrafficGraph />

      <div className="w-full h-[1px] bg-secondary my-6" />

      <div className="flex justify-between flex-col md:flex-row md:gap-x-8">
        <SourceMetrics />
        <div className="hidden md:block w-px bg-secondary self-stretch" />
        <div className="block md:hidden w-full h-[1px] bg-secondary my-6" />
        <CountryMetrics />
      </div>

      <UserAgentMetrics />

      <CardMetrics />

      <FiltersBar />
    </>
  );
};

export default Analytics;
